<template>
  <v-container class="pt-10">

    <v-row v-if="!library.id">
      <v-col>
        <v-skeleton-loader
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row class="pb-10" v-else>

      <v-col v-if="showCover"
             xs="12"
             md="3">
        <v-img :src="library.cover"
               max-height="400"
               contain
               @click="goToReader"/>
      </v-col>

      <v-col class="px-10" align-self="center">

        <div class="text-center">
          <p class="font-weight-bold"
             :class="{ 'text-h2':!this.isMobile, 'text-h4':this.isMobile }">
            {{ library.title }}
          </p>

          <div v-html="library.description"></div>

          <v-row class="text-center mt-10">
            <v-col>
              <v-btn x-large
                     class="mx-5 my-3"
                     v-if="canRead"
                     @click="goToReader">
                <v-icon v-if="library.ctaIcon"
                          class="mr-3"
                          v-text="library.ctaIcon"></v-icon>
                <book-open-icon size="1.5x" 
                                class="mr-3"
                                v-else/>
                {{ library.ctaLabel }}
              </v-btn>
              <v-btn x-large
                     class="mx-5 my-3"
                     v-for="cta in library.ctas"
                     :key="cta.id"
                     :href="cta.url"
                     target="_blank">
                <v-icon class="mr-2">{{ cta.icon }}</v-icon>
                {{ cta.label }}
              </v-btn>
            </v-col>
          </v-row>

        </div>

      </v-col>

    </v-row>

    <!-- issues -->
    <div v-if="isLoading" class="mt-10">
      <v-row v-if="library.isGrid">
        <v-col v-for="i in issuesCols"
               :key="i">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"
           ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-skeleton-loader
          class="mx-auto"
          type="list-item-three-line"
          v-else
       ></v-skeleton-loader>
    </div>

    <div v-if="library.hasIssues">
      
      <Grid :items="library.sortedIssues"
            class="mt-10 pb-10"
            v-if="library.isGrid"
            @click="onIssueClick"
            gradient/>

      <List :items="library.sortedIssues"
            class="mt-10 pb-10"
            v-else-if="library.isList"
            @click="onIssueClick"
            gradient/>

    </div>

    <!-- more libraries -->
    <p class="text-center mt-10 py-10"
       :class="{ 'text-h4':!this.isMobile, 'text-h5':this.isMobile }">
      Potrebbe interessarti anche...
    </p>
    <Grid :items="moreLibraries"
          :loading="isLoadingMore"
          @click="goToLibrary"/>

  </v-container>
</template>

<script>
import API from '@/api'
let cancelToken

import { mapGetters, mapMutations } from 'vuex'

import slug from '@/mixins/slug'
import utility from '@/mixins/utility'

import Grid from '@/components/Grids/Simple'
import List from '@/components/Grids/List'

import { BookOpenIcon } from 'vue-feather-icons'

export default {
  
  name: 'Library',

  mixins: [ slug, utility ],

  components:
  {
    Grid,
    List,
    // icons.
    BookOpenIcon
  },

  data: () => ({
    isLoadingMore: false,
    library: {},
    moreLibraries: []
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading'
    }),

    canBuy()
    {
      return (this.library.canBuy 
              && !this.library.hasBought
              && this.library.store)
    },

    canRead()
    {
      let hasFile = this.hasFile,
          lastIssue = this.lastIssue,
          issueHasFile = (lastIssue && lastIssue.hasFile),
          checkFile = ( hasFile || issueHasFile ),
          canRead = this.library.canRead

      return (checkFile && canRead)
    },

    hasFile()
    {
      return (this.library.embed || this.library.pdf)
    },

    issuesCols()
    {
      return this.isMobile ? 2 : 4
    },

    lastIssue()
    {
      return this.library.sortedIssues ? this.library.sortedIssues[0] : null
    },

    otherIssues()
    {
      let lastIssues = this.library.sortedIssues

      return lastIssues.filter((i, issue)=>{
        return i ? issue : false
      })
    },

    showCover()
    {
      return this.library.cover
    }
  },

  methods: 
  {
    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    goToLibrary(library)
    {
      let params = { slug:library.slug, library }

      this.goTo({ name:'library', params })
    },

    goToReader()
    {
      let params = {}

      if( !this.canRead )
        return

      if( this.hasFile )
        params = { 
          model: this.library,
          modelType: 'library', 
          slug: this.library.slug
        }

      else if ( this.lastIssue && this.lastIssue.hasFile )
        params = { 
          model: this.lastIssue,
          modelType: 'issue', 
          slug: this.lastIssue.slug
        }

      this.goTo({ name:'reader', params })
    },

    load()
    {
      this.loadLibrary()

      this.loadMore()
    },

    loadLibrary()
    {
      if( this.$route.params.library )
        this.library = this.$route.params.library

      if( !this.slug )
        return
      
      this.setLoading('linear')

      cancelToken = API.cancelToken()

      API.library.one(
                    this.slug, 
                    { include:'issues,ctas', withPermissions:true },
                    { cancelToken: cancelToken.token }
                  )
                 .then(({ data })=>{

                  this.library = this.mapModel(data.data, 'library')

                  this.setLoading(false)

                 })
                 .catch((err)=>{
                  if( !API.isCancel(err) )
                    this.goTo('error')
                 })
    },

    loadMore()
    {
      this.isLoadingMore = true

      API.library.list({ 'page[size]':6 })
                 .then(({ data })=>{

                  this.moreLibraries = this.mapModels(data.data, 'library')

                 })
                 .finally(()=>this.isLoadingMore=false)
    },

    onIssueClick(issue)
    {
      let checkAuth = ( this.library.canRead || issue.canRead )

      if( issue.hasFile && checkAuth )
        this.goTo({
          name: 'reader',
          params: {
            modelType: 'issue',
            slug: issue.slug,
            model: issue
          }
        })
    },

    onSlugChange()
    {
      this.setLoading()
    }
  },

  mounted()
  {
    this.load()

    this.setBack('home')
  },

  unmounted()
  {

  },

  watch:
  {
    slug()
    {
      cancelToken.cancel()

      this.load()
    }
  }

}
</script>
